import { motion } from "motion/react";

// Journey Map Component
export default function JourneyMap({
  stages,
  experiences,
  expectations,
  painPoints,
  emotions,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8 }}
      className="p-6 sm:p-8 rounded-3xl item-border border-white/10 bg-white/5 space-y-8 mt-8"
    >
      {/* Stages */}
      <div className="grid grid-cols-6 lg:grid-cols-6 gap-4">
        {stages.map((stage, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="p-3 sm:p-4 rounded-2xl bg-[#D4B896] text-black text-center font-normal text-sm sm:text-base shadow-lg"
          >
            {stage}
          </motion.div>
        ))}
      </div>

      {/* Emotion Graph */}
      <div className="relative rounded-3xl item-border border-white/5 bg-gradient-to-b from-green-500/10 via-yellow-500/10 to-red-500/10">
          <img
            src="/assets/imgs/case-studies/ipm_5.png"
            alt="Fresh vegetables"
            className="w-full h-auto"
          />
      </div>

      {/* Experience */}
      <div className="p-6 rounded-2xl item-border border-[#D4B8964D] bg-[#D4B896]-light space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 rounded-full bg-[#FD5B38]" />
          <h4 className="text-white text-base font-normal">Experience</h4>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
          {experiences.map((exp, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="text-gray-200 text-sm"
            >
              {exp}
            </motion.p>
          ))}
        </div>
      </div>

      {/* Expectations */}
      <div className="p-6 rounded-2xl item-border border-[#D4B8964D] bg-[#D4B896]-light space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 rounded-full bg-[#FD5B38]" />
          <h4 className="text-white text-base font-normal">Expectations</h4>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
          {expectations.map((exp, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="text-gray-200 text-sm"
            >
              {exp}
            </motion.p>
          ))}
        </div>
      </div>

      {/* Pain Points */}
      <div className="p-6 rounded-2xl item-border border-[#D4B8964D] bg-[#D4B896]-light space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 rounded-full bg-[#FD5B38]" />
          <h4 className="text-white text-base font-normal">Pain Points</h4>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
          {painPoints.map((pain, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="text-gray-200 text-sm"
            >
              {pain}
            </motion.p>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
